import { createBitmapIcon } from './bitmap-icon';

export const ActionsLotus = createBitmapIcon(
    '/_n/images/fancy-landing/actions-lotus.svg'
);
